export const WHM_COMMON_MAP = {
    container: 'all',
    detail: ':whmAccountId',
    list: 'list',
    manage: 'manage'
};
